module.exports = __webpack_public_path__ + "static/img/menu-kc.d64102d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-kc.png
// module id = 25kt
// module chunks = 2